// shared-lib/millwork/colours.js
/**
 * Trim colours as the renderers read them: a hex string, a 0x number, or a
 * named colour. `NAMED_TRIM_COLOURS` is `DoorWithTrim.NAMED_COLORS`, moved
 * here so the casing paint and the 3D casing read one table.
 */
const NAMED_TRIM_COLOURS = Object.freeze({
  wood: 0x8b4513,
  white: 0xffffff,
  black: 0x2a2a2a,
  gray: 0x808080,
  grey: 0x808080,
  cream: 0xf5f5dc,
  navy: 0x1a1a4e,
  red: 0x8b0000,
  green: 0x2e5a2e,
  // hardware finishes (the door renderer reads them from the same table)
  chrome: 0xc0c0c0,
  brass: 0xb5a642,
  bronze: 0x4a3c2a,
});

// Persisted opening trim colour ids -> hex; web openingCasing.js imports this
// one table (its `trimHexFor` = `TRIM_HEX[id] || TRIM_HEX.white`).
const TRIM_HEX = Object.freeze({
  white: '#ffffff',
  cream: '#f5f5dc',
  gray: '#808080',
  black: '#2a2a2a',
});

const openingTrimHex = (colorId) => TRIM_HEX[colorId] || TRIM_HEX.white;

const fromNumber = (n) => `#${n.toString(16).padStart(6, '0').toUpperCase()}`;

/** '#RRGGBB' for anything a renderer would draw as a colour, else null. */
const trimColourHex = (value) => {
  if (
    typeof value === 'number' &&
    Number.isInteger(value) &&
    value >= 0 &&
    value <= 0xffffff
  ) {
    return fromNumber(value);
  }
  if (typeof value !== 'string') return null;
  const v = value.trim().toLowerCase();
  const hex = /^#?([0-9a-f]{6})$/.exec(v) || /^0x([0-9a-f]{6})$/.exec(v);
  if (hex) return `#${hex[1].toUpperCase()}`;
  return Object.hasOwn(NAMED_TRIM_COLOURS, v)
    ? fromNumber(NAMED_TRIM_COLOURS[v])
    : null;
};

module.exports = {
  NAMED_TRIM_COLOURS,
  TRIM_HEX,
  openingTrimHex,
  trimColourHex,
};
